import { renderMessageBarBody_unstable } from '@fluentui/react-message-bar';

/**
 * Renders the final JSX of the MessageBarBody component, given the state and context values.
 */
export const renderMessageBarBody = renderMessageBarBody_unstable;
